/* eslint-disable no-console -- logs the parsed map and localStorage failures for debugging */
import { makeVar } from "@apollo/client";
import * as Sentry from "@sentry/nextjs";

export type LastActiveInvestingEntityMap = {
	[accountId: string]: string; // mapping of accountId → investingEntityId
};

const localStorageKey = "last_active_investing_entity_map";

export const lastActiveInvestingEntityVar =
	makeVar<LastActiveInvestingEntityMap>({});

export const setLastActiveInvestingEntity = ({
	investingEntityId,
	accountId,
}: {
	investingEntityId: string;
	accountId: string;
}) => {
	try {
		const raw = localStorage.getItem(localStorageKey);
		const current = raw ? JSON.parse(raw) : {};
		const updated = {
			...current,
			[accountId]: investingEntityId,
		};

		localStorage.setItem(localStorageKey, JSON.stringify(updated));
		lastActiveInvestingEntityVar(updated);

		// Tag subsequent Sentry events with the active investing entity so captured
		// errors can be attributed (APP-23988). Covers entity switches and the
		// post-login redirect (auth-redirect → set-active-investing-entity/[id]),
		// which are the paths that flow through this setter. A plain reload that
		// doesn't re-activate an entity won't re-apply the tag — Sentry tags don't
		// survive a page load — but SetLoggerUser still attributes events by user id
		// + route on every load.
		Sentry.setTag("investing-entity-id", investingEntityId);
	} catch {
		console.error("Error saving last active investing entity");
	}
};

export const hydrateLastActiveInvestingEntity = () => {
	try {
		const raw = localStorage.getItem(localStorageKey);
		if (raw) {
			const parsed: LastActiveInvestingEntityMap = JSON.parse(raw);
			lastActiveInvestingEntityVar(parsed);
			console.log("parsed", parsed);
		}
	} catch {
		console.error("Error parsing last active investing entity map");
	}
};
